var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.286133 13.144C0.286133 6.0432 6.04247 0.286865 13.1433 0.286865H38.8576C45.9584 0.286865 51.7147 6.0432 51.7147 13.144V38.8583C51.7147 45.9591 45.9584 51.7154 38.8576 51.7154H13.1433C6.04247 51.7154 0.286133 45.9591 0.286133 38.8583V13.144Z",
    fill: "#F63220"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9934 22.4229C31.3839 22.0324 31.3839 21.3992 30.9934 21.0087C30.6029 20.6182 29.9697 20.6182 29.5792 21.0087L26.0006 24.5873L22.422 21.0087C22.0314 20.6182 21.3983 20.6182 21.0077 21.0087C20.6172 21.3992 20.6172 22.0324 21.0077 22.4229L24.5863 26.0015L21.0077 29.5801C20.6172 29.9707 20.6172 30.6038 21.0077 30.9944C21.3983 31.3849 22.0314 31.3849 22.422 30.9944L26.0006 27.4157L29.5792 30.9944C29.9697 31.3849 30.6029 31.3849 30.9934 30.9944C31.3839 30.6038 31.3839 29.9707 30.9934 29.5801L27.4148 26.0015L30.9934 22.4229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2aa5e0e50c42249eb60ea4d8a200e42b.svg";
export { ForwardRef as ReactComponent };